import { optionSchema } from "@/common/schemas/option.schema";
import { z } from "zod";

export const productPriceSchema = z.object({
  product: optionSchema.optional(),
  value: z.string().optional(),
});

export type ProductPriceValidationSchema = z.infer<typeof productPriceSchema>;
